// extracted by mini-css-extract-plugin
export default {"statusBox":"cdENyEkzVXmKF9LmPJJa","align-center":"G4wdYNpDAKDJjv9sirC3","align-start":"NxShBNSx4bYHLYCCuFmq","align-end":"C6B6WLrzhuKBId5qeyOI"};